import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CouponRegionEntity } from '../../domain/entities/CouponRegionEntity'

export class CreateUpdateCouponRegionModel extends CouponRegionEntity {
  regionId?: number
  districtIds?: number[]
  constructor(dataDto: CouponRegionEntity) {
    super()
    mapEntityProperties<CreateUpdateCouponRegionModel>(this, dataDto, {
      exclude: ['region', 'districts'],
      map: {
        regionId: dataDto.region?.id,
        districtIds: dataDto.districts?.map((district) => district.id)
      }
    })
  }
}
